import React, { useState } from 'react';
import * as Accordion from '@radix-ui/react-accordion';
import {
  MultilinkStoryblok,
  RichtextStoryblok,
} from '../../../../../types/storyblok';
import Link from '../../../../../base/Link/Link';
import { Box } from '../../../../../base/Box/Box';
import { Type } from '../../../../../base/Type/Type';
import Markup from '../../../../../base/Markup/Markup';
import MinusBlack from '../../../../../assets/icons/minus-black.svg';
import PlusBlack from '../../../../../assets/icons/plus-black.svg';
import MinusWhite from '../../../../../assets/icons/minus-white.svg';
import PlusWhite from '../../../../../assets/icons/plus-white.svg';
import isDarkColour from '../../../../../utils/isDarkColour';

type Props = {
  text: RichtextStoryblok;
  link: MultilinkStoryblok;
  heading: string;
  colourScheme: string;
};

const darkIcons = {
  plus: PlusWhite,
  minus: MinusWhite,
};

const lightIcons = {
  plus: PlusBlack,
  minus: MinusBlack,
};

const getIcon = (colourScheme: string, icon: 'plus' | 'minus') =>
  isDarkColour(colourScheme) ? darkIcons[icon] : lightIcons[icon];

export const Dropdown = ({ text, link, heading, colourScheme }: Props) => {
  const [itemOpen, setItemOpen] = useState('');

  return (
    <Accordion.Root
      type="single"
      collapsible
      value={itemOpen}
      onValueChange={setItemOpen}
    >
      <Accordion.Item key={heading} value={heading}>
        <Accordion.Header>
          <Box
            as="div"
            className="mt-3 flex flex-row items-end justify-between"
          >
            <Link href={link} className="font-helvetica text-h3 lg:text-h1">
              {heading}
            </Link>
            <Accordion.Trigger>
              <Type
                as="span"
                className="hidden lg:block underline font-foundersGrotesk text-p1 w-28 lg:w-32 hover:opacity-80"
              >
                {itemOpen ? 'Read less -' : 'Read more +'}
              </Type>
              <Box
                as="div"
                className="flex lg:hidden hover:opacity-80 items-center justify-center h-[25px] w-[25px]"
              >
                <Type as="span" className="text-[30px]">
                  {itemOpen ? (
                    <img src={getIcon(colourScheme, 'minus')} />
                  ) : (
                    <img src={getIcon(colourScheme, 'plus')} />
                  )}
                </Type>
              </Box>
            </Accordion.Trigger>
          </Box>
        </Accordion.Header>
        <Accordion.Content>
          <Box as="div" className="py-2 max-w-full md:max-w-[85%]">
            <Markup
              content={text}
              className="[&>*]:font-foundersGrotesk [&>p]:text-p1"
            />
          </Box>
        </Accordion.Content>
      </Accordion.Item>
    </Accordion.Root>
  );
};
